export default __webpack_public_path__ + "static/media/14564.magazine-committee.photo.4ea6f66b.jpg";